import * as XLSX from 'xlsx/xlsx.mjs';

class ExportManagePortalUsersUtility {
  private static Instance: ExportManagePortalUsersUtility;
  private static DEFAULT_MESSAGE = 'No records were found.';

  static getInstance() {
    if (ExportManagePortalUsersUtility.Instance == null)
      ExportManagePortalUsersUtility.Instance = new ExportManagePortalUsersUtility();

    return this.Instance;
  }

  ExportData(userData: IPortalUser[], agencyName: string, agencyNumber: string) {
    //const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const fileName = 'UserList_';
    let date = new Date();
    let today =
      (date.getMonth() + 1).toString() + '/' + date.getDate().toString() + '/' + date.getFullYear().toString();
    const title = 'Business Lines Portal Users on ' + today + ' from Liberty Mutual Insurance®';

    let workbook = XLSX.utils.book_new();
    workbook.Props = {
      Title: title,
      Subject: 'Business Lines Portal Users',
      Author: 'Liberty Mutual Insurance',
      CreatedDate: date,
    };

    let worksheet = this.CreateWorksheet(userData, agencyName, agencyNumber);
    XLSX.utils.book_append_sheet(workbook, worksheet);
    XLSX.writeFile(workbook, fileName + today + fileExtension);
  }

  CreateWorksheet(portalUsers: IPortalUser[], agencyName: string, agencyNumber: string): any {
    let worksheet = XLSX.utils.json_to_sheet(portalUsers, { origin: 2 });
    if (portalUsers.length > 0) {
      let date = new Date();
      let today =
        (date.getMonth() + 1).toString() + '/' + date.getDate().toString() + '/' + date.getFullYear().toString();
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [[agencyName + ': ' + agencyNumber + ' Liberty Mutual portal user data from: ' + today]],
        { origin: 0 },
      );
    } else {
      XLSX.utils.sheet_add_aoa(worksheet, [[ExportManagePortalUsersUtility.DEFAULT_MESSAGE]], { origin: 'A4' });
    }
    var wscols = [{ wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 40 }, { wch: 10 }, { wch: 30 }];

    worksheet['!cols'] = wscols;
    worksheet['!merges'] = [{ s: { c: 0, r: 0 }, e: { c: 5, r: 0 } }];
    return worksheet;
  }
}

export default ExportManagePortalUsersUtility;
